/*!
 * renderapp.js
 * http://renderapp.co
 *
 * Copyright 2022 Renderapp Limited
 */

import debug from 'debug'

import {
  normalise
} from '~/client/assets/js/common/render-data'

import {
  getDefaultConfigurationFromButtonObjects
} from './render-data/button-objects'

const log = debug('renderapp:default-configuration')

log('`renderapp` is awake')

export const defaultConfigurationMap = new Map()

export function hasDefaultConfigurationFor (configuration = '') {
  log('hasDefaultConfigurationFor')

  let defaultConfiguration = false

  if (configuration.includes('+170')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = true
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = true
    }
  } else if (configuration.includes('+175')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = true
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = true
    }
  } else if (configuration.includes('+270')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = true
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = true
    }
  } else if (configuration.includes('+310')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = true
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = true
    }
  } else if (configuration.includes('+360')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = true
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = true
    }
  } else if (configuration.includes('+420')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = true
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = true
    }
  } else if (configuration.includes('+620')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = true
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = true
    }
  } else if (configuration.includes('+275')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = true
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = true
    }
  } else if (configuration.includes('+340')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = true
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = true
    }
  } else if (configuration.includes('+485')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = true
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = true
    }
  } else if (configuration.includes('+36S')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = true
    }
  } else if (configuration.includes('+36R')) {
    if (configuration.includes('+RPC')) {
      defaultConfiguration = true
    }
  } else if (configuration.includes('+CSR')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = true
    }
  } else if (configuration.includes('+42C')) {
    defaultConfiguration = true
  } else if (configuration.includes('+42U')) {
    defaultConfiguration = true
  } else if (configuration.includes('+SUK')) {
    defaultConfiguration = true
  } else if (configuration.includes('+S6H')) {
    defaultConfiguration = true
  } else if (configuration.includes('+S2K')) {
    defaultConfiguration = true
  } else if (configuration.includes('+S6U')) {
    defaultConfiguration = true
  } else if (configuration.includes('+S2U')) {
    defaultConfiguration = true
  } else if (configuration.includes('+SSU')) { // SUPER SEVEN (US)
    defaultConfiguration = true
  } else if (configuration.includes('+SEU')) {
    defaultConfiguration = true
  }

  return defaultConfiguration
}

export function getDefaultConfigurationFor (configuration = '') {
  log('getDefaultConfigurationFor')

  let defaultConfiguration = ''

  if (configuration.includes('+170')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = '+170+SPC'
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = '+170+RPC'
    }
  } else if (configuration.includes('+175')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = '+175+SPC'
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = '+175+RPC'
    }
  } else if (configuration.includes('+270')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = '+270+SPC'
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = '+270+RPC'
    }
  } else if (configuration.includes('+310')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = '+310+SPC'
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = '+310+RPC'
    }
  } else if (configuration.includes('+360')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = '+360+SPC'
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = '+360+RPC'
    }
  } else if (configuration.includes('+420')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = '+420+SPC'
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = '+420+RPC'
    }
  } else if (configuration.includes('+620')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = '+620+SPC'
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = '+620+RPC'
    }
  } else if (configuration.includes('+275')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = '+275+SPC'
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = '+275+RPC'
    }
  } else if (configuration.includes('+340')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = '+340+SPC'
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = '+340+RPC'
    }
  } else if (configuration.includes('+485')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = '+485+SPC'
    } else if (configuration.includes('+RPC')) {
      defaultConfiguration = '+485+RPC'
    }
  } else if (configuration.includes('+36S')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = '+36S+SPC'
    }
  } else if (configuration.includes('+36R')) {
    if (configuration.includes('+RPC')) {
      defaultConfiguration = '+36R+RPC'
    }
  } else if (configuration.includes('+CSR')) {
    if (configuration.includes('+SPC')) {
      defaultConfiguration = '+CSR+SPC'
    }
  } else if (configuration.includes('+42C')) {
    defaultConfiguration = '+42C'
  } else if (configuration.includes('+42U')) {
    defaultConfiguration = '+42U'
  } else if (configuration.includes('+SUK')) {
    defaultConfiguration = '+SUK'
  } else if (configuration.includes('+S6H')) {
    defaultConfiguration = '+S6H'
  } else if (configuration.includes('+S2K')) {
    defaultConfiguration = '+S2K'
  } else if (configuration.includes('+S6U')) {
    defaultConfiguration = '+S6U'
  } else if (configuration.includes('+S2U')) {
    defaultConfiguration = '+S2U'
  } else if (configuration.includes('+SSU')) { // SUPER SEVEN (US)
    defaultConfiguration = '+SSU'
  } else if (configuration.includes('+SEU')) {
    defaultConfiguration = '+SEU'
  }

  if (!defaultConfiguration) return ''

  // 620 toggle (US-only). Append +62SU / +62RU to the canonical seed when
  // present in the live configuration, so DEF clauses keyed on +62SU+SPC
  // (Pass 4 CLONE rows + Pass 2 RP cells) match at init-time cascade.
  // UK never carries +62SU/+62RU (zero-collision lemma) -> inert for UK.
  if (defaultConfiguration.includes('+SPC') && configuration.includes('+62SU')) {
    defaultConfiguration = defaultConfiguration + '+62SU'
  } else if (defaultConfiguration.includes('+RPC') && configuration.includes('+62RU')) {
    defaultConfiguration = defaultConfiguration + '+62RU'
  }

  if (defaultConfigurationMap.has(defaultConfiguration)) {
    defaultConfiguration = defaultConfigurationMap.get(defaultConfiguration)
  } else {
    defaultConfigurationMap.set(defaultConfiguration, (defaultConfiguration = normalise(defaultConfiguration.concat(getDefaultConfigurationFromButtonObjects(defaultConfiguration)))))
  }

  return defaultConfiguration
}

export function hasDefaultConfiguration (frontEndRule = '', configuration = '') {
  log('hasDefaultConfiguration')

  let defaultConfiguration = false

  // S PACK
  if (frontEndRule === '+170' || (frontEndRule === '+SPC' && configuration.includes('+170'))) {
    defaultConfiguration = true
  } else if (frontEndRule === '+175' || (frontEndRule === '+SPC' && configuration.includes('+175'))) {
    defaultConfiguration = true
  } else if (frontEndRule === '+270' || (frontEndRule === '+SPC' && configuration.includes('+270'))) {
    defaultConfiguration = true
  } else if (frontEndRule === '+310' || (frontEndRule === '+SPC' && configuration.includes('+310'))) {
    defaultConfiguration = true
  } else if (frontEndRule === '+360' || (frontEndRule === '+SPC' && configuration.includes('+360'))) {
    defaultConfiguration = true
  } else if (frontEndRule === '+420' || (frontEndRule === '+SPC' && configuration.includes('+420'))) {
    defaultConfiguration = true
  } else if (frontEndRule === '+620' || (frontEndRule === '+SPC' && configuration.includes('+620'))) {
    defaultConfiguration = true
  } else if (frontEndRule === '+275' || (frontEndRule === '+SPC' && configuration.includes('+275'))) {
    defaultConfiguration = true
  } else if (frontEndRule === '+340' || (frontEndRule === '+SPC' && configuration.includes('+340'))) {
    defaultConfiguration = true
  } else if (frontEndRule === '+485' || (frontEndRule === '+SPC' && configuration.includes('+485'))) {
    defaultConfiguration = true
  } else if (frontEndRule === '+36S' || (frontEndRule === '+SPC' && configuration.includes('+36S'))) {
    defaultConfiguration = true
  } else if (frontEndRule === '+36R' || (frontEndRule === '+RPC' && configuration.includes('+36R'))) {
    defaultConfiguration = true
  } else if (frontEndRule === '+CSR' || (frontEndRule === '+SPC' && configuration.includes('+CSR'))) {
    defaultConfiguration = true
  } else if (frontEndRule === '+RPC') {
    // R PACK
    if (configuration.includes('+170')) {
      defaultConfiguration = true
    } else if (configuration.includes('+175')) {
      defaultConfiguration = true
    } else if (configuration.includes('+270')) {
      defaultConfiguration = true
    } else if (configuration.includes('+310')) {
      defaultConfiguration = true
    } else if (configuration.includes('+360')) {
      defaultConfiguration = true
    } else if (configuration.includes('+420')) {
      defaultConfiguration = true
    } else if (configuration.includes('+620')) {
      defaultConfiguration = true
    } else if (configuration.includes('+275')) {
      defaultConfiguration = true
    } else if (configuration.includes('+340')) {
      defaultConfiguration = true
    } else if (configuration.includes('+485')) {
      defaultConfiguration = true
    } else if (configuration.includes('+36R')) {
      defaultConfiguration = true
    }
  } else if (frontEndRule === '+42C') {
    defaultConfiguration = true
  } else if (frontEndRule === '+42U') {
    defaultConfiguration = true
  } else if (frontEndRule === '+SUK') { // SUPER SEVEN
    defaultConfiguration = true
  } else if (frontEndRule === '+S6H') { // SUPER SEVEN
    defaultConfiguration = true
  } else if (frontEndRule === '+S2K') { // SUPER SEVEN
    defaultConfiguration = true
  } else if (frontEndRule === '+S6U') { // SUPER SEVEN
    defaultConfiguration = true
  } else if (frontEndRule === '+S2U') { // SUPER SEVEN
    defaultConfiguration = true
  } else if (frontEndRule === '+SSU') { // SUPER SEVEN (US)
    defaultConfiguration = true
  } else if (frontEndRule === '+SEU') {
    defaultConfiguration = true
  } else if (frontEndRule === '+62SU' && configuration.includes('+SPC')) { // 620S toggle (US-only)
    defaultConfiguration = true
  } else if (frontEndRule === '+62RU' && configuration.includes('+RPC')) { // 620R toggle (US-only)
    defaultConfiguration = true
  }

  return defaultConfiguration
}

export function getDefaultConfiguration (frontEndRule = '', configuration = '') {
  log('getDefaultConfiguration')

  let defaultConfiguration = ''

  // S PACK
  if (frontEndRule === '+170' || (frontEndRule === '+SPC' && configuration.includes('+170'))) {
    defaultConfiguration = '+170+SPC'
  } else if (frontEndRule === '+175' || (frontEndRule === '+SPC' && configuration.includes('+175'))) {
    defaultConfiguration = '+175+SPC'
  } else if (frontEndRule === '+270' || (frontEndRule === '+SPC' && configuration.includes('+270'))) {
    defaultConfiguration = '+270+SPC'
  } else if (frontEndRule === '+310' || (frontEndRule === '+SPC' && configuration.includes('+310'))) {
    defaultConfiguration = '+310+SPC'
  } else if (frontEndRule === '+360' || (frontEndRule === '+SPC' && configuration.includes('+360'))) {
    defaultConfiguration = '+360+SPC'
  } else if (frontEndRule === '+420' || (frontEndRule === '+SPC' && configuration.includes('+420'))) {
    defaultConfiguration = '+420+SPC'
  } else if (frontEndRule === '+620' || (frontEndRule === '+SPC' && configuration.includes('+620'))) {
    defaultConfiguration = '+620+SPC'
  } else if (frontEndRule === '+275' || (frontEndRule === '+SPC' && configuration.includes('+275'))) {
    defaultConfiguration = '+275+SPC'
  } else if (frontEndRule === '+340' || (frontEndRule === '+SPC' && configuration.includes('+340'))) {
    defaultConfiguration = '+340+SPC'
  } else if (frontEndRule === '+485' || (frontEndRule === '+SPC' && configuration.includes('+485'))) {
    defaultConfiguration = '+485+SPC'
  } else if (frontEndRule === '+36S' || (frontEndRule === '+SPC' && configuration.includes('+36S'))) {
    defaultConfiguration = '+36S+SPC'
  } else if (frontEndRule === '+36R' || (frontEndRule === '+RPC' && configuration.includes('+36R'))) {
    defaultConfiguration = '+36R+RPC'
  } else if (frontEndRule === '+CSR' || (frontEndRule === '+SPC' && configuration.includes('+CSR'))) {
    defaultConfiguration = '+CSR+SPC'
  } else if (frontEndRule === '+RPC') {
    // R PACK
    if (configuration.includes('+170')) {
      defaultConfiguration = '+170+RPC'
    } else if (configuration.includes('+175')) {
      defaultConfiguration = '+175+RPC'
    } else if (configuration.includes('+270')) {
      defaultConfiguration = '+270+RPC'
    } else if (configuration.includes('+310')) {
      defaultConfiguration = '+310+RPC'
    } else if (configuration.includes('+360')) {
      defaultConfiguration = '+360+RPC'
    } else if (configuration.includes('+420')) {
      defaultConfiguration = '+420+RPC'
    } else if (configuration.includes('+620')) {
      defaultConfiguration = '+620+RPC'
    } else if (configuration.includes('+275')) {
      defaultConfiguration = '+275+RPC'
    } else if (configuration.includes('+340')) {
      defaultConfiguration = '+340+RPC'
    } else if (configuration.includes('+485')) {
      defaultConfiguration = '+485+RPC'
    } else if (configuration.includes('+36R')) {
      defaultConfiguration = '+36R+RPC'
    }
  } else if (frontEndRule === '+42C') {
    defaultConfiguration = '+42C'
  } else if (frontEndRule === '+42U') {
    defaultConfiguration = '+42U'
  } else if (frontEndRule === '+SUK') { // SUPER SEVEN
    defaultConfiguration = '+SUK'
  } else if (frontEndRule === '+S6H') { // SUPER SEVEN
    defaultConfiguration = '+S6H'
  } else if (frontEndRule === '+S2K') { // SUPER SEVEN
    defaultConfiguration = '+S2K'
  } else if (frontEndRule === '+S6U') { // SUPER SEVEN
    defaultConfiguration = '+S6U'
  } else if (frontEndRule === '+S2U') { // SUPER SEVEN
    defaultConfiguration = '+S2U'
  } else if (frontEndRule === '+SSU') { // SUPER SEVEN (US)
    defaultConfiguration = '+SSU'
  } else if (frontEndRule === '+SEU') {
    defaultConfiguration = '+SEU'
  } else if (frontEndRule === '+62SU' && configuration.includes('+SPC')) {
    // 620S toggle (US-only). US tiles always emit +360 model -> seed includes
    // +62SU so DEF clauses keyed on +62SU+SPC (Pass 4 CLONE rows + Pass 2 RP)
    // match. Other model bases left as fall-through.
    if (configuration.includes('+360')) {
      defaultConfiguration = '+360+SPC+62SU'
    } else if (configuration.includes('+36S')) {
      defaultConfiguration = '+36S+SPC+62SU'
    }
  } else if (frontEndRule === '+62RU' && configuration.includes('+RPC')) {
    // 620R toggle (US-only). Mirror of +62SU.
    if (configuration.includes('+360')) {
      defaultConfiguration = '+360+RPC+62RU'
    } else if (configuration.includes('+36R')) {
      defaultConfiguration = '+36R+RPC+62RU'
    }
  }

  if (!defaultConfiguration) return ''

  if (defaultConfigurationMap.has(defaultConfiguration)) {
    defaultConfiguration = defaultConfigurationMap.get(defaultConfiguration)
  } else {
    defaultConfigurationMap.set(defaultConfiguration, (defaultConfiguration = normalise(defaultConfiguration.concat(getDefaultConfigurationFromButtonObjects(defaultConfiguration)))))
  }

  return defaultConfiguration
}
